import React, { useContext, useEffect, useState } from 'react';
import { PublicEnvironmentVariables } from 'types';
import GlobalContext from 'hooks/contexts/GlobalContext';
import { getCookie } from 'utils/analyticsHelpers';
import { SettingsIconButton } from './components/common/SettingsIconButton';
import { ConfigModal } from './components/ConfigModal';

const bannerStyle = {
  position: 'fixed',
  bottom: '0px',
  right: '0px',
  background: 'black',
  padding: '0px 10px',
  color: 'white',
  zIndex: 100,
};

function DevWidget({
  env,
}: {
  env: PublicEnvironmentVariables;
}): React.JSX.Element {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mounted, setMounted] = useState(false);
  const {
    sessionInfo: { userSessionId },
  } = useContext(GlobalContext);

  useEffect(() => {
    setMounted(true);
  }, []);

  const toggleModal = (): void => {
    setIsModalOpen(!isModalOpen);
  };

  const backendDomain =
    getCookie('triadBackendDomain') || env.triadBackendDomain;

  return (
    <div>
      <SettingsIconButton onClick={toggleModal} />
      <ConfigModal
        isOpen={isModalOpen}
        onClose={toggleModal}
        environmentVariables={env}
      />
      <span style={bannerStyle as React.CSSProperties}>
        session id: {mounted ? userSessionId : ''} | backend domain:{' '}
        {backendDomain}
      </span>
    </div>
  );
}

export default DevWidget;
